// Icons for the primary dashboard cards (style H: bold filled icon, left aligned).
// Keyed by the card's `abbr`. Org dashboard configs store their own (older) icon names,
// so the map wins and the stored icon is only a fallback for cards not listed here.
const ICONS = {
  academic: 'school',
  advisors: 'support_agent',
  births: 'child_friendly',
  certifications: 'workspace_premium',
  checklist: 'checklist',
  community: 'groups',
  events: 'event',
  exam_results: 'fact_check',
  explore: 'explore',
  externships: 'medical_services',
  interviews: 'record_voice_over',
  jobs: 'work',
  license_verifications: 'verified',
  my_info: 'person',
  paths: 'trending_up',
  research: 'science',
  resources: 'folder_open',
  skills: 'volunteer_activism',
  sponsorships: 'stars',
};

export function cardIcon(abbr, fallback = 'dashboard') {
  return ICONS[abbr] || fallback;
}
